<template>
    <div>
        <el-table
            :data="tableData"
            style="width: 100%"
            :cell-style="{
                'font-size': '16px',
                color: '#333',
            }"
            :header-cell-style="{
                'background-color': '#d7d7d7',
                'font-weight': '700',
                color: '#333',
                'font-size': '16px',
            }"
        >
            <el-table-column label="序号" align="center" header-align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.$index + 1 }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="课程名称"
                prop="type"
                align="center"
                header-align="center"
            >
                <template slot-scope="scope">
                    <div
                        style="cursor: pointer"
                        @click="linkTo(scope.$index, scope.row)"
                    >
                        {{ scope.row.type }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="课程代码"
                prop="total"
                align="center"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                label="考试方式"
                prop="signingUp"
                align="center"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                label="课程学分"
                prop="learning"
                align="center"
                header-align="center"
            >
            </el-table-column>
            <el-table-column
                label="学习中课程"
                prop="notLearn"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="报名中"
                prop="studyOver"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="未开课"
                prop="learnNum"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                label="已结课"
                prop="studyNum"
                align="center"
                header-align="center"
            ></el-table-column>
        </el-table>
        <Select></Select>
        <TableOne></TableOne>
    </div>
</template>

<script>
import Select from "./select.vue";
import TableOne from "./TableOne.vue";
export default {
    data() {
        return {
            tableData: [
                {
                    type: "班级课程",
                    total: "1",
                    signingUp: "2",
                    learning: "3",
                    notLearn: "4",
                    studyOver: "5",
                    learnNum: "6",
                    studyNum: "7",
                },
            ],
        };
    },
    components: {
        Select,
        TableOne,
    },
    methods: {
        linkTo(i, item) {
            console.log(item);
        },
    },
};
</script>

<style lang="scss" scoped>
.el-table {
    margin-top: 0px;
}
</style>